module.exports = __webpack_public_path__ + "static/media/DINbek-01.4445f7dd.svg";